'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Breadcrumb;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
* An item in the hierarchy path of the page the user is on.
* @category Layout
*/

/* eslint-disable no-script-url */


function Breadcrumb(props) {
  var href = props.href,
      label = props.label,
      onClick = props.onClick,
      disabled = props.disabled,
      className = props.className,
      style = props.style;

  var getClassNames = function getClassNames() {
    return (0, _classnames2.default)('rainbow-breadcrumb', {
      'rainbow-breadcrumb--disabled': disabled
    }, className);
  };

  return _react2.default.createElement('li', {
    className: getClassNames(),
    style: style
  }, _react2.default.createElement('a', {
    className: 'rainbow-breadcrumb-anchor',
    href: href,
    onClick: onClick,
    'aria-disabled': !!disabled
  }, label));
}

Breadcrumb.propTypes = {
  /** The text label for the breadcrumb. */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,

  /** The URL of the page that the breadcrumb goes to. */
  href: _propTypes2.default.string,

  /** The action triggered when the breadcrumb is clicked. */
  onClick: _propTypes2.default.func,

  /** Specifies that a breadcrumb element should be disabled. This value defaults to false. */
  disabled: _propTypes2.default.bool,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2.default.string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2.default.object
};
Breadcrumb.defaultProps = {
  href: 'javascript:void(0);',
  onClick: function onClick() {},
  disabled: false,
  className: undefined,
  style: undefined
};